import { CustomListItemStyleItem } from './CustomListItemStyleItem'

export const Multiple = new CustomListItemStyleItem({
  id: '0ab8790c-2fac-42e9-84cb-f68c4061c665',
  name: 'Multiple',
  label: 'Multiple - a dropdown where multiple items can be selected',
  help: 'a dropdown where multiple items can be selected',
})
export const Single = new CustomListItemStyleItem({
  id: '19f01fab-2bfc-4075-b3bf-2f40d5fcf1f9',
  label: 'Single - a dropdown where only a single item can be selected',
  help: 'a dropdown where only a single item can be selected',
  name: 'Single',
})
export const Checkboxes = new CustomListItemStyleItem({
  id: '5b4050cc-dd6f-4ce7-967d-e5f41b58a208',
  label: 'Checkboxes - all items behave as checkboxes',
  help: 'all items behave as checkboxes',
  name: 'Checkboxes',
})
